import { render, staticRenderFns } from "./Info-personal.vue?vue&type=template&id=1cc6c0ba&"
import script from "./Info-personal.vue?vue&type=script&lang=js&"
export * from "./Info-personal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports